<template>
  <div class="door-home" @scroll="handleScroll" ref="scrollContainer">
    <div class="door-header">
      <div class="door-nav">
        <div class="door-logo">
          <img src="../../../assets/door/logotwo.svg" alt=""  style="height: 50px; width: auto"/>
        </div>
        <div class="door-info">
          <div class="door-info-telephone">
            <div class="tele-box">
              <img src="../../../assets/door/telephone.png" alt="" />
            </div>

            <div>15204753660</div>
          </div>
          <div class="door-info-contact" @click="guidanceDialogOpen">
            联系我们
          </div>
        </div>
      </div>
      <video
        autoplay
        muted
        loop
        width="100%"
        height="100%"
        id="videoCarousel"
        style="object-fit: cover; object-position: center center; width: 100%"
      >
        <source src="../../../assets/door/video.mp4" type="video/mp4" />
      </video>
      <div class="door-title-box">
        <div class="door-title">
          <img src="../../../assets/door/banner.png" alt="" />
        </div>
        <div class="door-btn" @click="gotoSign">
          加入我们
          <img src="../../../assets/door/arrow.png" alt="" />
        </div>
      </div>
      <div class="door-card">
        <div class="door-card-item" v-for="item in cardList" :key="item">
          <div class="door-card-img"></div>
          <div class="door-card-title">{{ item.title }}</div>
          <div class="door-card-discript">{{ item.info }}</div>
        </div>
      </div>
    </div>
    <div class="bj"></div>
    <div class="zhhq">
      <div class="zTop">
        <h1 class="market-title">
          <span class="title-center">全国碳市场每日综合行情 </span>
          <span class="title-right">更新时间:{{ Datetime }}</span>
        </h1>
      </div>
      <div class="zMain">
        <div class="zLeft">
          <div class="lTop">
            <p>最新</p>
            <div>
              <span class="sps1">{{ Number(close).toLocaleString() }}</span>
              <span class="sps2">元</span>
            </div>
          </div>
          <div class="lBottom">
            <div class="lBottom-left">
              <p>
                <span class="sps1">涨幅</span
                ><span :class="{ positive: rise >= 0, negative: rise < 0 }"
                  >{{ rise }}%</span
                >
              </p>
            </div>
            <div class="lBottom-right">
              <p>
                <span class="sps1">涨跌</span
                ><span
                  :class="{ positive: riseFall >= 0, negative: riseFall < 0 }"
                  >{{ riseFall }}</span
                >
              </p>
            </div>
          </div>
        </div>
        <div class="zRight">
          <div class="z-item">
            <div class="zleft">
              <img src="../images/tjy/kaipan .png" alt="" />
            </div>
            <div class="zright">
              <p class="P1">开盘</p>
              <p class="p2">
                <span class="sps1">{{ Number(open).toLocaleString() }}</span
                ><span class="sps2">元</span>
              </p>
            </div>
          </div>
          <div class="z-item">
            <div class="zleft">
              <img src="../images/tjy/最高.png" alt="" />
            </div>
            <div class="zright">
              <p class="P1">最高</p>
              <p class="p2">
                <span class="sps1">{{ Number(max).toLocaleString() }}</span
                ><span class="sps2">元</span>
              </p>
            </div>
          </div>
          <div class="z-item">
            <div class="zleft">
              <img src="../images/tjy/挂盘成交量.png" alt="" />
            </div>
            <div class="zright">
              <p class="P1">挂盘成交量</p>
              <p class="p2">
                <span class="sps1">{{ tradeCount }}</span
                ><span class="sps2">万吨</span>
              </p>
            </div>
          </div>
          <div class="z-item">
            <div class="zleft">
              <img src="../images/tjy/昨收.png" alt="" />
            </div>
            <div class="zright">
              <p class="P1">昨收</p>
              <p class="p2">
                <span class="sps1">{{
                  Number(yesterdayClose).toLocaleString()
                }}</span
                ><span class="sps2">元</span>
              </p>
            </div>
          </div>
          <div class="z-item">
            <div class="zleft">
              <img src="../images/tjy/最低.png" alt="" />
            </div>
            <div class="zright">
              <p class="P1">最低</p>
              <p class="p2">
                <span class="sps1">{{ Number(min).toLocaleString() }}</span
                ><span class="sps2">元</span>
              </p>
            </div>
          </div>
          <div class="z-item">
            <div class="zleft">
              <img src="../images/tjy/挂盘成交额.png" alt="" />
            </div>
            <div class="zright">
              <p class="P1">挂盘成交额</p>
              <p class="p2">
                <span class="sps1">{{
                  Number(tradeVolumn).toLocaleString()
                }}</span
                ><span class="sps2">万元</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cjy">
      <div class="cTop">
        <h1>碳交易撮合数据概览</h1>
        <p style="margin-top: 20px">
          聚焦碳交易撮合核心数据，汇总交易笔数、金额以及各类资产撮合详情，一屏掌握交易撮合动态
        </p>
      </div>
      <div class="cMain">
        <div class="mLeft">
          <h2>
            <span><img src="../images/tjy/累计交易撮合统计_1.png" alt /></span>
            <span class="sps2">累计交易撮合统计</span>
          </h2>
          <div class="lBottom">
            <div class="lBottom-item" style="margin-top: 10px">
              <div class="item-title">
                <span><img src="../images/tjy/总交易笔数.png" alt="" /></span
                ><span style="margin-left: 5px">总交易笔数</span>
              </div>
              <div class="item-num">
                <span class="num">{{ totalCount }}</span
                ><span class="yuan">笔</span>
              </div>
            </div>
            <div class="lBottom-item">
              <div class="item-title">
                <span><img src="../images/tjy/总交易金额.png" alt="" /></span>
                <span style="margin-left: 5px">总交易金额</span>
              </div>
              <div class="item-num">
                <span class="num">{{
                  Number(totalAmount).toLocaleString()
                }}</span>
                <span class="yuan">万元</span>
              </div>
            </div>
          </div>
        </div>
        <div class="mRight">
          <div class="rTop">
            <div
              class="rTop-item"
              style="background: linear-gradient(to bottom, #e6f9e4, #ffffff)"
            >
              <div class="title1">
                <div class="title2">
                  <span><img src="../images/tjy/绿证.png" alt="" /></span
                  ><span class="bt">绿证</span>
                </div>
                <div class="title3">
                  <span class="bt">总笔数</span>
                  <p>
                    <span class="num">{{ lztotalCount }}</span
                    ><span class="dw">笔</span>
                  </p>
                </div>
              </div>
              <div class="items">
                <div class="title-item">
                  <div class="item-title">总金额</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(lztotalAmount).toLocaleString()
                    }}</span
                    ><span class="dw">万元</span>
                  </div>
                </div>
                <div class="title-item">
                  <div class="item-title">成交均价</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(lzaveragePrice).toLocaleString()
                    }}</span
                    ><span class="dw">元/个</span>
                  </div>
                </div>
                <div class="title-item">
                  <div class="item-title">最高价</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(lzmaxPrice).toLocaleString()
                    }}</span
                    ><span class="dw">元/个</span>
                  </div>
                </div>
                <div class="title-item">
                  <div class="item-title">最低价</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(lzminPrice).toLocaleString()
                    }}</span
                    ><span class="dw">元/个</span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="rTop-item"
              style="
                background: linear-gradient(180deg, #e8f4ff 0%, #ffffff 100%);
              "
            >
              <div class="title1">
                <div class="title2">
                  <span><img src="../images/tjy/配额.png" alt="" /></span
                  ><span class="bt">配额</span>
                </div>
                <div class="title3">
                  <span class="bt">总笔数</span>
                  <p>
                    <span class="num">{{ petotalCount }}</span
                    ><span class="dw">笔</span>
                  </p>
                </div>
              </div>
              <div class="items">
                <div class="title-item">
                  <div class="item-title">总金额</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(petotalAmount).toLocaleString()
                    }}</span
                    ><span class="dw">万元</span>
                  </div>
                </div>
                <div class="title-item">
                  <div class="item-title">成交均价</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(peaveragePrice).toLocaleString()
                    }}</span
                    ><span class="dw">元/tco2</span>
                  </div>
                </div>
                <div class="title-item">
                  <div class="item-title">最高价</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(pemaxPrice).toLocaleString()
                    }}</span
                    ><span class="dw">元/tco2</span>
                  </div>
                </div>
                <div class="title-item">
                  <div class="item-title">最低价</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(peminPrice).toLocaleString()
                    }}</span
                    ><span class="dw">元/tco2</span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="rTop-item"
              style="
                background: linear-gradient(180deg, #e8fcff 0%, #ffffff 100%);
              "
            >
              <div class="title1">
                <div class="title2">
                  <span><img src="../images/tjy/CCEr.png" alt="" /></span
                  ><span class="bt">CCER</span>
                </div>
                <div class="title3">
                  <span class="bt">总笔数</span>
                  <p>
                    <span class="num">{{ ertotalCount }}</span
                    ><span class="dw">笔</span>
                  </p>
                </div>
              </div>
              <div class="items">
                <div class="title-item">
                  <div class="item-title">总金额</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(ertotalAmount).toLocaleString()
                    }}</span
                    ><span class="dw">万元</span>
                  </div>
                </div>
                <div class="title-item">
                  <div class="item-title">成交均价</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(eraveragePrice).toLocaleString()
                    }}</span
                    ><span class="dw">元/tco2</span>
                  </div>
                </div>
                <div class="title-item">
                  <div class="item-title">最高价</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(ermaxPrice).toLocaleString()
                    }}</span
                    ><span class="dw">元/tco2</span>
                  </div>
                </div>
                <div class="title-item">
                  <div class="item-title">最低价</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(erminPrice).toLocaleString()
                    }}</span
                    ><span class="dw">元/tco2</span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="rTop-item"
              style="
                background: linear-gradient(180deg, #f9f9e7 0%, #ffffff 100%);
              "
            >
              <div class="title1">
                <div class="title2">
                  <span><img src="../images/tjy/绿电.png" alt="" /></span
                  ><span class="bt">绿电</span>
                </div>
                <div class="title3">
                  <span class="bt">总笔数</span>
                  <p>
                    <span class="num">{{ ldtotalCount }}</span
                    ><span class="dw">笔</span>
                  </p>
                </div>
              </div>
              <div class="items">
                <div class="title-item">
                  <div class="item-title">总金额</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(ldtotalAmount).toLocaleString()
                    }}</span
                    ><span class="dw">万元</span>
                  </div>
                </div>
                <div class="title-item">
                  <div class="item-title">成交均价</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(ldaveragePrice).toLocaleString()
                    }}</span
                    ><span class="dw">元/MWh</span>
                  </div>
                </div>
                <div class="title-item">
                  <div class="item-title">最高价</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(ldmaxPrice).toLocaleString()
                    }}</span
                    ><span class="dw">元/MWh</span>
                  </div>
                </div>
                <div class="title-item">
                  <div class="item-title">最低价</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(ldminPrice).toLocaleString()
                    }}</span
                    ><span class="dw">元/MWh</span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="rTop-item"
              style="
                background: linear-gradient(180deg, #eaf2f8 0%, #ffffff 100%);
              "
            >
              <div class="title1">
                <div class="title2">
                  <span><img src="../images/tjy/碳汇.png" alt="" /></span
                  ><span class="bt">碳汇</span>
                </div>
                <div class="title3">
                  <span class="bt">总笔数</span>
                  <p>
                    <span class="num">{{ thtotalCount }}</span
                    ><span class="dw">笔</span>
                  </p>
                </div>
              </div>
              <div class="items">
                <div class="title-item">
                  <div class="item-title">总金额</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(thtotalAmount).toLocaleString()
                    }}</span
                    ><span class="dw">万元</span>
                  </div>
                </div>
                <div class="title-item">
                  <div class="item-title">成交均价</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(thaveragePrice).toLocaleString()
                    }}</span
                    ><span class="dw">元/tco2</span>
                  </div>
                </div>
                <div class="title-item">
                  <div class="item-title">最高价</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(thmaxPrice).toLocaleString()
                    }}</span
                    ><span class="dw">元/tco2</span>
                  </div>
                </div>
                <div class="title-item">
                  <div class="item-title">最低价</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(thminPrice).toLocaleString()
                    }}</span
                    ><span class="dw">元/tco2</span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="rTop-item"
              style="
                background: linear-gradient(180deg, #e4e3f9 0%, #ffffff 100%);
              "
            >
              <div class="title1">
                <div class="title2">
                  <span><img src="../images/tjy/VCS.png" alt="" /></span
                  ><span class="bt">VCS</span>
                </div>
                <div class="title3">
                  <span class="bt">总笔数</span>
                  <p>
                    <span class="num">{{ cstotalCount }}</span
                    ><span class="dw">笔</span>
                  </p>
                </div>
              </div>
              <div class="items">
                <div class="title-item">
                  <div class="item-title">总金额</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(cstotalAmount).toLocaleString()
                    }}</span
                    ><span class="dw">万元</span>
                  </div>
                </div>
                <div class="title-item">
                  <div class="item-title">成交均价</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(csaveragePrice).toLocaleString()
                    }}</span
                    ><span class="dw">元/tco2</span>
                  </div>
                </div>
                <div class="title-item">
                  <div class="item-title">最高价</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(csmaxPrice).toLocaleString()
                    }}</span
                    ><span class="dw">元/tco2</span>
                  </div>
                </div>
                <div class="title-item">
                  <div class="item-title">最低价</div>
                  <div class="item-num">
                    <span class="yuanNum">{{
                      Number(csminPrice).toLocaleString()
                    }}</span
                    ><span class="dw">元/tco2</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="header-title-box">
      <div class="header-title">产品与服务</div>
      <div class="header-title-info">
        技术赋能低碳发展，构建覆盖碳监测、碳盘查、碳核算、碳认证等全链条的服务体系
      </div>
    </div>
    <div class="right-nav" :style="{ top: scrollY + 'px' }">
      <div class="nav-item" @click="handleRightNav('1')">
        <div class="img-box"></div>
        <div class="nav-title">政府服务</div>
      </div>
      <div class="nav-item" @click="handleRightNav('2')">
        <div class="img-box"></div>
        <div class="nav-title">企业服务</div>
      </div>
<div class="nav-item" @click="handleRightNav('3')">
        <div class="img-box"></div>
        <div class="nav-title">免费试用</div>
      </div>
      <!--      <div class="nav-item" @click="handleRightNav('4')">
        <div class="img-box"></div>
        <div class="nav-title">碳普惠服务</div>
      </div>-->
      <div class="nav-item" @click="handleRightNav('5')">
        <div class="img-box"></div>
        <div class="nav-title">联系我们</div>
      </div>
      <div class="nav-item" @click="handleRightNav('6')">
        <div class="img-box"></div>
      </div>
    </div>
    <div class="common-monitor carbon-monitor">
      <div class="container-center">
        <div class="container-left">
          <img src="../../../assets/door/carbonMonitor.png" alt="" />
        </div>
        <div class="container-right">
          <div class="product-title">
            能碳在线<span class="active">监测</span>
          </div>
          <div class="product-line"></div>
          <div class="product-box-title">
            平台提供能耗在线监测、碳排放实时监测、碳排放在线核算、碳核算因子管理等功能模块，实现能碳数据在线监测，以及碳排放数据的计算和分析。
          </div>
          <div class="product-box-info">
            <div class="product-box-info-item">
              <span class="bg-icon"> <span></span> </span
              >实时跟踪能源消耗与碳排放情况
            </div>
            <div class="product-box-info-item">
              <span class="bg-icon"> <span></span></span
              >数据智能分析，两高环节精准定位
            </div>
            <div class="product-box-info-item">
              <span class="bg-icon"> <span></span></span
              >助力寻找节能减碳协同的最佳路径
            </div>
          </div>
          <div class="product-box-btn" @click="gotoSignFree">免费试用</div>
        </div>
      </div>
    </div>
    <div class="common-show">
      <div class="container-center">
        <div class="container-left">
          <div class="product-title">
            碳交易<span class="active">撮合</span>
          </div>
          <div class="product-line"></div>
          <div class="product-box-title">
            帮助用户对各类碳资产进行统筹管理，利用先进的交易撮合算法系统，为买卖双方提供高效、便捷的能碳交易撮合服务，降低交易成本，提高市场效率。
          </div>
          <div class="product-box-info">
            <div class="product-box-info-item">
              <span class="bg-icon"> <span></span> </span
              >帮助企业碳资产运营策略化
            </div>
            <div class="product-box-info-item">
              <span class="bg-icon"> <span></span></span>低成本高效率参与碳交易
            </div>
            <div class="product-box-info-item">
              <span class="bg-icon"> <span></span></span
              >碳账本数据可视化，辅助企业经营决策
            </div>
          </div>
          <div class="product-box-btn" @click="gotoSignFree">免费试用</div>
        </div>
        <div class="container-right">
          <img src="../../../assets/door/carbonMatch.png" alt="" />
        </div>
      </div>
    </div>
    <div class="common-monitor carbon-calendar">
      <div class="container-center">
        <div class="container-left">
          <img src="../../../assets/door/carbonCal.png" alt="" />
        </div>
        <div class="container-right">
          <div class="product-title">
            企业组织<span class="active">碳核算</span>
          </div>
          <div class="product-line"></div>
          <div class="product-box-title">
            平台为各类园区和工业企业提供碳排放核算模型、排放因子管理、碳核算与报告等功能，全方位支持碳排放核算与管理工作运行。
          </div>
          <div class="product-box-info">
            <div class="product-box-info-item">
              <span class="bg-icon"> <span></span> </span
              >核算易操作，数据准确可靠
            </div>
            <div class="product-box-info-item">
              <span class="bg-icon"> <span></span></span
              >快速生成符合标准的碳核算报告
            </div>
            <div class="product-box-info-item">
              <span class="bg-icon"> <span></span></span>多维度数据展示分析
            </div>
          </div>
          <div class="product-box-btn" @click="gotoSignFree">免费试用</div>
        </div>
      </div>
    </div>
    <div class="common-show">
      <div class="container-center">
        <div class="container-left">
          <div class="product-title">
            企业<span class="active">减排项目</span>管理
          </div>
          <div class="product-line"></div>
          <div class="product-box-title">
            识别企业或园区各碳排放环节并深入分析，制定源头减碳、过程降碳等技术方案，结合平台智能工具，提供碳减排项目管理、碳减排量核算分析等服务。
          </div>
          <div class="product-box-info">
            <div class="product-box-info-item">
              <span class="bg-icon"> <span></span> </span
              >实时跟踪减排项目运行情况
            </div>
            <div class="product-box-info-item">
              <span class="bg-icon"> <span></span></span
              >减排减排效果全面比较分析
            </div>
            <div class="product-box-info-item">
              <span class="bg-icon"> <span></span></span
              >帮助企业制定长效减排策略
            </div>
          </div>
          <div class="product-box-btn" @click="gotoSignFree">免费试用</div>
        </div>
        <div class="container-right">
          <img src="../../../assets/door/carbonzixun.png" alt="" />
        </div>
      </div>
    </div>
    <div class="public-box">
      <div class="public-center">
        <div class="public-title">公共服务</div>
        <div class="public-content">
          <div class="public-left">
            <div class="carousel-top">
              <el-carousel
                ref="carousel"
                indicator-position="none"
                style="width: 100%; height: 353px"
                @change="handleCarousel"
              >
                <el-carousel-item
                  v-for="(item, index) in indictorList"
                  style="height: 100%; position: absolute"
                  :key="index"
                >
                  <img
                    :src="item.img"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                  <div class="indictorInfo">
                    <div class="indictorInfoLeft">
                      {{ item.discript }}
                    </div>
                    <div class="indictorInfoRight">
                      {{ item.active }}/{{ item.total }}
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="carousel-bottom">
              <div
                @click="handleItem(item)"
                :class="
                  activeCurrentNews == index
                    ? 'carousel-bottom-item carousel-bottom-item-active'
                    : 'carousel-bottom-item'
                "
                v-for="(item, index) in picturShowBox"
                :key="index"
                :style="{ backgroundImage: `url(${item.img})` }"
              ></div>
            </div>
          </div>
          <div class="public-right">
            <div class="public-btn-box">
              <div
                :class="activeNew == '双碳要闻' ? 'btn active' : 'btn'"
                @click="handleNews('双碳要闻')"
              >
                <a href="javascript:;">双碳要闻</a>
              </div>
              <div
                :class="activeNew == '政策解读' ? 'btn active' : 'btn'"
                @click="handleNews('政策解读')"
              >
                <a href="javascript:;">政策解读</a>
              </div>
              <div
                :class="activeNew == '案例分析' ? 'btn active' : 'btn'"
                @click="handleNews('案例分析')"
              >
                <a href="javascript:;">案例分析</a>
              </div>
              <div
                :class="activeNew == '技术共享' ? 'btn active' : 'btn'"
                @click="handleNews('技术共享')"
              >
                <a href="javascript:;">技术共享</a>
              </div>
              <div
                :class="activeNew == '平台咨询' ? 'btn active' : 'btn'"
                @click="handleNews('平台咨询')"
              >
                <a href="javascript:;">平台咨询</a>
              </div>
            </div>
            <div class="public-info-list">
              <div
                class="public-info-item"
                v-for="item in activeNews"
                :key="item"
              >
                <div
                  class="public-item-left"
                  @click="
                    wordDetail(
                      item.index,
                      item.name,
                      item.title,
                      item.publishTime
                    )
                  "
                >
                  <span></span>
                  {{ item.title }}
                </div>
                <div class="public-item-right">
                   {{ item.publishTime && item.publishTime.length > 0 
                    ? item.publishTime.slice(0, 10) 
                    : '无发布时间' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="public-btn" @click="goToMore">
          更多新闻<span style="margin-left: 5px">&gt;</span>
        </div>
      </div>
    </div>
    <div class="download-box">
      <div class="download-center">
        <div class="download-title">下载专区</div>
        <div class="download-content">
          <div class="download-item" @click="downloadFile('1')">
            <div class="download-item-img">
              <img src="../../../assets/door/PDF.png" alt="" />
            </div>
            <div class="download-item-info">
              工业企业和园区数字化能碳管理中心建设指南(工信厅节〔2025〕13号)
            </div>
          </div>
          <div class="download-item" @click="downloadFile('2')">
            <div class="download-item-img">
              <img src="../../../assets/door/PDF.png" alt="" />
            </div>
            <div class="download-item-info">
              工业企业温室气体排放核算和报告通则(GBT 32150-2015)
            </div>
          </div>
          <div class="download-item" @click="downloadFile('3')">
            <div class="download-item-img">
              <img src="../../../assets/door/PDF.png" alt="" />
            </div>
            <div class="download-item-info">
              综合能耗计算通则（GBT 2589-2020）
            </div>
          </div>
          <div class="download-item" @click="downloadFile('4')">
            <div class="download-item-img">
              <img src="../../../assets/door/PDF.png" alt="" />
            </div>
            <div class="download-item-info">
              企业温室气体排放核算与报告指南 钢铁行业
            </div>
          </div>
          <div class="download-item" @click="downloadFile('7')">
            <div class="download-item-img">
              <img src="../../../assets/door/PDF.png" alt="" />
            </div>
            <div class="download-item-info">
              企业温室气体排放核算与报告指南 铝冶炼行业
            </div>
          </div>
          <div class="download-item" @click="downloadFile('5')">
            <div class="download-item-img">
              <img src="../../../assets/door/PDF.png" alt="" />
            </div>
            <div class="download-item-info">
              企业温室气体排放核算与报告指南 水泥行业
            </div>
          </div>
          <!-- <div class="download-item" @click="downloadFile('6')">
            <div class="download-item-img">
              <img src="../../../assets/door/PDF.png" alt="" />
            </div>
            <div class="download-item-info">
              温室气体产品碳足迹量化要求和指南（GBT 24067）
            </div>
          </div>
          <div class="download-item" @click="downloadFile('8')">
            <div class="download-item-img">
              <img src="../../../assets/door/PDF.png" alt="" />
            </div>
            <div class="download-item-info">CBAM填报示例文件</div>
          </div> -->
          <div class="download-item" @click="downloadFile('9')">
            <div class="download-item-img">
              <img src="../../../assets/door/PDF.png" alt="" />
            </div>
            <div class="download-item-info">
              组织层面温室气体排放量和清除量量化和报告指南规范（iso14064-1）
            </div>
          </div>
          <div class="download-item" @click="downloadFile('10')">
            <div class="download-item-img">
              <img src="../../../assets/door/PDF.png" alt="" />
            </div>
            <div class="download-item-info">温室气体排放核算与报告要求
              <div>炭素材料生产企业</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-box">
      <div class="footer-center">
        <div class="footer-contact">
          <div class="contact-img">
            <div class="consult-service" @click="guidanceDialogOpen">
              <img src="../../../assets/door/contact.png" alt="" />
              <span>咨询</span>
            </div>
            <div class="QR">
              <img src="../../../assets/door/QR.png" alt="" />
            </div>
          </div>
          <div class="contact-info">
            <div class="contact-title">产品服务</div>
            <div class="contact-divide-line"></div>
            <div class="contact-item">能碳监测</div>
            <div class="contact-item">碳账户</div>
            <div class="contact-item">碳核算</div>
            <div class="contact-item">交易撮合</div>
            <div class="contact-item">碳资产</div>
            <div class="contact-item">碳减排</div>
          </div>
          <div class="contact-info">
            <div class="contact-title">公共服务</div>
            <div class="contact-divide-line"></div>
            <div class="contact-item">双碳要闻</div>
            <div class="contact-item">政策解读</div>
            <div class="contact-item">案例分析</div>
            <div class="contact-item">技术共享</div>
            <div class="contact-item">平台咨询</div>
          </div>
          <div class="contact-info">
            <div class="contact-title">技术引擎</div>
            <div class="contact-divide-line"></div>
            <div class="contact-item">工业大数据</div>
            <div class="contact-item">AI智能分析</div>
            <div class="contact-item">云计算</div>
            <div class="contact-item">安全管控</div>
            <div class="contact-item">边缘计算</div>
            <div class="contact-item">物联网</div>
          </div>
          <div class="contact-extra">
            <div class="contact-title">联系我们</div>
            <div class="contact-divide-line"></div>
            <div class="contact-logo">
              <img src="../../../assets/door/logotwo2.svg" alt="" style="width: auto"/>
            </div>
            <div class="contact-infos">
              <div class="left-img-logo">
                <img src="../../../assets/door/dianhua.png" alt="" />
              </div>
              <div class="info">
                <span style="line-height: 30px">联系方式：</span>
                <span style="line-height: 30px">15204753660</span>
              </div>
            </div>
            <div class="contact-infos">
              <div class="left-img-logo">
                <img src="../../../assets/door/youxiang.png" alt="" />
              </div>
              <div class="info">
                <span style="line-height: 30px">企业邮箱：</span>
                <span style="line-height: 30px">tlsxtxny@163.com</span>
              </div>
            </div>
            <div class="contact-infos">
              <div class="left-img-logo">
                <img src="../../../assets/door/dizhi.png" alt="" />
              </div>

              <div class="info" style="width: 500px">
                <span style="line-height: 30px">联系地址：</span>
                <span style="line-height: 30px">通辽经济技术开发区乌兰花路以东、叫来河大街以北生物科技大厦6楼</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="footer-link">
          <span>友情链接：</span>
          <a @click="gotoLink1">通辽市生态环境局</a>
          <a @click="gotoLink2">通辽市发展和改革委员会</a>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="guidanceDialog"
      width="30%"
      class="guidanceBox"
      append-to-body
    >
      <div class="headerBox">
        <div class="titleInfoBox">
          <p class="title1">免费咨询<img src="../images/咨询.svg" /></p>
          <span class="title2"
            >请填写以下信息，收到信息我们会第一时间联系您!</span
          >
        </div>
      </div>
      <div class="bodyBox">
        <el-form ref="guidanForm" :model="guidanForm" label-width="80px">
          <el-form-item label="公司名称">
            <el-input v-model="guidanForm.entName"></el-input>
          </el-form-item>
          <el-form-item label="联系人">
            <el-input v-model="guidanForm.contact"></el-input>
          </el-form-item>
          <el-form-item label="联系方式">
            <el-input v-model="guidanForm.phoneNumber"></el-input>
          </el-form-item>
          <el-form-item label="业务需求">
            <el-input type="textarea" v-model="guidanForm.demand"></el-input>
          </el-form-item>
        </el-form>
        <el-button class="submitBox" @click="handlesubmit">提交</el-button>
      </div>
      <div class="closeBox" @click="guidanceDialog = false"></div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import * as Setting from "@/setting";
import * as SettingUpdate from "@/settingUpdate";
import { getHalo, setToken, getHaloUrl } from "@/setting";
import { setTokenNew } from "@/settingUpdate";
const cacheBuster = (url) => `${url}?cb=${Date.now()}`;
const config = {
  headers: {
    Authorization: "Bearer pat_eyJraWQiOiJiOFJTWW90SWdrSERaWTZUWEt4X3NVbjcxRy1XRXp2THQ1UkJsTGVrbkJJIiwiYWxnIjoiUlMyNTYifQ.eyJpc3MiOiJodHRwOi8vMS4yNi4yMzYuMTgzOjE4MDA0LyIsInN1YiI6ImhhbG9hZG1pbiIsImlhdCI6MTc2MTEwODc3MywianRpIjoiZTQwNDQ5ZjMtMGI4ZS0xOGE3LWQ0NzUtZWEwZTk3MzlmZTNhIiwicGF0X25hbWUiOiJwYXQtaGFsb2FkbWluLW9QREFXIn0.bU5HcDqLvYyqtvcWl7qKoIGHAqIup2RuM43LW0aY_1frGQLq0OlCvJ6jH3fpBwuTygbeYmjB-uzYnJLgYeERNL4uvl6EAdhRcBkjk9AwNZwp3CILrg8IadsmdbU3mlLpcylHXSUbG7c-Q4rpTJ6nMPyP0AYsH2qk8QwR8p_rgjYOTX8vpyXeNecad0Gl1XlKRWrVOdKg15SuQM3Uy_IFH6-jPBJZihBPjmQlpLgngP35dLUQ6CKWkGw2OsYowg9qHiORXJa9F7OQdUdXOP9SF5_mh507kKItGibfLd8pL3WfTPbIq665sAJ3x43L1n10GXltKT4FS4Qe4L0-kNIuTiKR1hvZ6NY1tvvjc2JRdWrtL8KF9uhCaiyaTrhz4aKRAo5Q-7csTc5LENrcoySn5kdpaOqlLLV-Xk-lV1hxarCoYnp_B2mP0Yvu-lhJzJPmMIqmDCDriGB69wObpTiIVoEo7WpkM5sj6kOrNiuSo653TDG0vtokIWP3FR0eQ1iWK3-Ae_gNTfJgVY7rxkvrLNk0PacXm8gPkNwAA_gNJNlSherIB_QJDFSnxGH4M5EovtDeD4dK0UDJ-xuwV0d_bVMfUzU0colJkXHrvp3b0gxGw0pzitXhoLJIgVbsJisH3MOzYR8QqG4N6zHhiqrEptcxaZMFwTvRB40QkrA4d9o", // 设置认证令牌
    // Authorization: "Basic aGFsb2FkbWluOkNhUmJvbkAyNC4y", // 设置认证令牌
    // 'Authorization': 'Basic c3ViaW5naGU6MTIzNDU2', // 设置认证令牌
    // 'Authorization': 'Basic YWRtaW46Rmd3XzIwMjQh', // 设置认证令牌
    "Content-Type": "application/json", // 设置内容类型为JSON
  },
};
import { getPermssion } from "@/setting";
import { encrypt } from "@/jsencrypt";
import video1 from "@/assets/1.mp4";
import video2 from "@/assets/2.mp4";
import dayjs from "dayjs";
import { tradeStatisticsCumulative, tradeStatistics } from "@/api/Home";

export default {
  data() {
    return {
      Datetime: "",
      indictorList: [],
      picturBox: [],
      picturShowBox: [],
      activeCurrentNews: 0,
      cardList: [
        {
          title: "全链服务·碳路先锋",
          info: "一站式能碳管理，从监测到优化，全程精准护航",
        },
        {
          title: "精准施策·智启未来",
          info: "依托数据智能实现精准施策，为决策提供科学支撑，共同开创发展新格局",
        },
        {
          title: "智慧减碳·长效增益",
          info: "用数字化杠杆撬动碳资产价值，省的是成本，赢的是未来",
        },
        {
          title: "绿色智能·能效革命",
          info: "数据洞察全局，智能算法赋能，打造企业低碳金名片",
        },
      ],
      guidanceDialog: false,
      guidanForm: {
        entName: "",
        contact: "",
        phoneNumber: "",
        demand: "",
      },
      activeNews: [],
      scrollY: 811,
      activeNew: "双碳要闻",
      totalCount: "",
      totalAmount: "",
      lztotalCount: "",
      lztotalAmount: "",
      lzaveragePrice: "",
      lzmaxPrice: "",
      lzminPrice: "",
      petotalCount: "",
      petotalAmount: "",
      peaveragePrice: "",
      pemaxPrice: "",
      peminPrice: "",
      ertotalCount: "",
      ertotalAmount: "",
      eraveragePrice: "",
      ermaxPrice: "",
      erminPrice: "",
      ldtotalCount: "",
      ldtotalAmount: "",
      ldaveragePrice: "",
      ldmaxPrice: "",
      ldminPrice: "",
      thtotalCount: "",
      thtotalAmount: "",
      thaveragePrice: "",
      thmaxPrice: "",
      thminPrice: "",
      cstotalCount: "",
      cstotalAmount: "",
      csaveragePrice: "",
      csmaxPrice: "",
      csminPrice: "",
      close: "",
      rise: "",
      riseFall: "",
      open: "",
      max: "",
      tradeCount: "",
      yesterdayClose: "",
      min: "",
      tradeVolumn: "",
      carbonMarketTimer: null, // 添加定时器引用
    };
  },

  methods: {
    getNews() {
      axios({
        method: "get",
        url: "/door/enterprise/door/DoorCarbonTrade/tradeStatisticsCumulative",
      }).then((res) => {
        if (res.data.code == 200) {
          this.totalCount = res.data.data.totalCount;
          this.totalAmount = (res.data.data.totalAmount / 10000).toFixed(2);
        }
      });
      axios({
        method: "get",
        url: "/door/enterprise/door/DoorCarbonTrade/tradeStatistics",
        params: {
          assetType: "绿证",  
        },
      }).then((res) => {
        if (res.data.code == 200) {
          (this.lztotalCount = res.data.data.totalCount),  
            (this.lztotalAmount = (res.data.data.totalAmount / 10000).toFixed(
              2
            ));
          this.lzaveragePrice = res.data.data.averagePrice.toFixed(2);
          this.lzmaxPrice = res.data.data.maxPrice.toFixed(2);
          this.lzminPrice = res.data.data.minPrice.toFixed(2);
        }
      });
      axios({
        method: "get",
        url: "/door/enterprise/door/DoorCarbonTrade/tradeStatistics",
        params: {
          assetType: "配额",
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.petotalCount = res.data.data.totalCount;
          this.petotalAmount = (res.data.data.totalAmount / 10000).toFixed(2);
          this.peaveragePrice = res.data.data.averagePrice.toFixed(2);
          this.pemaxPrice = res.data.data.maxPrice.toFixed(2);
          this.peminPrice = res.data.data.minPrice.toFixed(2);
        }
      });
      axios({
        method: "get",
        url: "/door/enterprise/door/DoorCarbonTrade/tradeStatistics",
        params: {
          assetType: "CCER",
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.ertotalCount = res.data.data.totalCount;
          this.ertotalAmount = (res.data.data.totalAmount / 10000).toFixed(2);
          this.eraveragePrice = res.data.data.averagePrice.toFixed(2);
          this.ermaxPrice = res.data.data.maxPrice.toFixed(2);
          this.erminPrice = res.data.data.minPrice.toFixed(2);
        }
      });
      axios({
        method: "get",
        url: "/door/enterprise/door/DoorCarbonTrade/tradeStatistics",
        params: {
          assetType: "绿电",
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.ldtotalCount = res.data.data.totalCount;
          this.ldtotalAmount = (res.data.data.totalAmount / 10000).toFixed(2);
          this.ldaveragePrice = res.data.data.averagePrice.toFixed(2);
          this.ldmaxPrice = res.data.data.maxPrice.toFixed(2);
          this.ldminPrice = res.data.data.minPrice.toFixed(2);
        }
      });
      axios({
        method: "get",
        url: "/door/enterprise/door/DoorCarbonTrade/tradeStatistics",
        params: {
          assetType: "碳汇",
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.thtotalCount = res.data.data.totalCount;
          this.thtotalAmount = (res.data.data.totalAmount / 10000).toFixed(2);
          this.thaveragePrice = res.data.data.averagePrice.toFixed(2);
          this.thmaxPrice = res.data.data.maxPrice.toFixed(2);
          this.thminPrice = res.data.data.minPrice.toFixed(2);
        }
      });
      axios({
        method: "get",
        url: "/door/enterprise/door/DoorCarbonTrade/tradeStatistics",
        params: {
          assetType: "VCS",
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.cstotalCount = res.data.data.totalCount;
          this.cstotalAmount = (res.data.data.totalAmount / 10000).toFixed(2);
          this.csaveragePrice = res.data.data.averagePrice.toFixed(2);
          this.csmaxPrice = res.data.data.maxPrice.toFixed(2);
          this.csminPrice = res.data.data.minPrice.toFixed(2);
        }
      });
      // axios({
      //   method: "get",
      //   url: "/door/enterprise/door/CarbonMarket/statistics",
      // }).then((res) => {
      //   if (res.data.code == 200) {
      //     this.close = res.data.data.close.toFixed(2);
      //     this.rise = res.data.data.rise.toFixed(2);
      //     this.riseFall = res.data.data.riseFall.toFixed(2);
      //     this.open = res.data.data.open.toFixed(2);
      //     this.max = res.data.data.max.toFixed(2);
      //     this.tradeCount = res.data.data.tradeCount.toFixed(2);
      //     this.yesterdayClose = res.data.data.yesterdayClose.toFixed(2);
      //     this.min = res.data.data.min.toFixed(2);
      //     this.tradeVolumn = res.data.data.tradeVolumn.toFixed(2);
      //   }
      // });
    },

    // 获取碳市场统计数据
    getCarbonMarketStatistics() {
       console.log('正在调用碳市场数据接口...'); // 添加调试日志
      axios({
        method: "get",
        url: "/door/enterprise/door/CarbonMarket/statistics",
      }).then((res) => {
         console.log('碳市场数据接口响应:', res); // 添加调试日志
        if (res.data.code == 200) {
          this.close = res.data.data.close.toFixed(2);
          this.rise = res.data.data.rise.toFixed(2);
          this.riseFall = res.data.data.riseFall.toFixed(2);
          this.open = res.data.data.open.toFixed(2);
          this.max = res.data.data.max.toFixed(2);
          this.tradeCount = res.data.data.tradeCount.toFixed(2);
          this.yesterdayClose = res.data.data.yesterdayClose.toFixed(2);
          this.min = res.data.data.min.toFixed(2);
          this.tradeVolumn = res.data.data.tradeVolumn.toFixed(2);
        } else {
          console.error('碳市场数据接口返回错误:', res.data);
        }
      });
    },

    // 开始定时更新碳市场数据
    startCarbonMarketTimer() {
      // 立即执行一次
      this.getCarbonMarketStatistics();
           // 清除可能已存在的定时器
      if (this.carbonMarketTimer) {
        clearInterval(this.carbonMarketTimer);
      }
      // 每10分钟执行一次 (10 * 60 * 1000毫秒)
      this.carbonMarketTimer = setInterval(() => {
        this.getCarbonMarketStatistics();
      }, 10 * 60 * 1000);
      // }, 3000);
    },
    // 停止定时更新
    stopCarbonMarketTimer() {
      if (this.carbonMarketTimer) {
        clearInterval(this.carbonMarketTimer);
        this.carbonMarketTimer = null;
      }
    },
    handleScroll(val) {
      if (val.target.scrollTop > 20) {
        this.scrollY = 400;
      } else {
        this.scrollY = 811;
      }
    },
    wordDetail(index, id, contentTitle, contentDate) {
      if (this.activeNew == "双碳要闻") {
        let pathInfo = this.$router.resolve({
          path: "/wordDetail",
          query: {
            titleName: this.activeNew,
            activeName: 2,
            resultIndex: index,
            contentId: id,
            contentTitle: contentTitle,
            contentDate: contentDate,
          },
        });
        window.open(pathInfo.href, "_blank");
      } else if (this.activeNew == "政策解读") {
        let pathInfo = this.$router.resolve({
          path: "/wordDetail",
          query: {
            titleName: this.activeNew,
            activeName: 4,
            resultIndex: index,
            contentId: id,
            contentTitle: contentTitle,
            contentDate: contentDate,
          },
        });
        window.open(pathInfo.href, "_blank");
      } else if (this.activeNew == "案例分析") {
        let pathInfo = this.$router.resolve({
          path: "/wordDetail",
          query: {
            titleName: this.activeNew,
            activeName: 6,
            resultIndex: index,
            contentId: id,
            contentTitle: contentTitle,
            contentDate: contentDate,
          },
        });
        window.open(pathInfo.href, "_blank");
      } else if (this.activeNew == "技术共享") {
        let pathInfo = this.$router.resolve({
          path: "/wordDetail",
          query: {
            titleName: this.activeNew,
            activeName: 7,
            resultIndex: index,
            contentId: id,
            contentTitle: contentTitle,
            contentDate: contentDate,
          },
        });
        window.open(pathInfo.href, "_blank");
      } else if (this.activeNew == "平台咨询") {
        let pathInfo = this.$router.resolve({
          path: "/wordDetail",
          query: {
            titleName: this.activeNew,
            activeName: 9,
            resultIndex: index,
            contentId: id,
            contentTitle: contentTitle,
            contentDate: contentDate,
          },
        });
        window.open(pathInfo.href, "_blank");
      }
    },
    initNew() {
      this.activeCurrentNews = 0;
      this.picturShowBox = [];
      this.activeNews = [];
      this.picturBox = [];
      this.indictorList = [];
      if (this.activeNew == "双碳要闻") {
        axios
          .get(
            Setting.getHalo() +
              "/v1alpha1/posts?page=1&size=8&labelSelector=content.halo.run%2Fdeleted%3Dfalse&fieldSelector=spec.categories%3D76514a40-6ef1-4ed9-b58a-e26945bde3ca&keyword=",
            config
          )
          .then((res) => {
            if (res.data.items.length != 0) {
              let index = 1;
              let total = 0;
              for (let i = 0; i < res.data.items.length; i++) {
                let item1 = res.data.items[i];
                if (item1.post.spec.cover) {
                  total += 1;
                }
              }
              for (let i = 0; i < res.data.items.length; i++) {
                let item1 = res.data.items[i];
                if (item1.post.spec.cover) {
                  let obj = {
                    img: item1.post.spec.cover ?'https://ntgl.tlsyjxndc.com:18004' +  item1.post.spec.cover : null,
                    discript: item1.post.spec.title,
                    active: index,
                    total: total,
                  };
                  this.indictorList.push(obj);
                  this.picturBox.push(obj);
                  index++;
                }
                let obj2 = {
                  index: i,
                  title: item1.post.spec.title,
                  name: item1.post.metadata.name,
                  publishTime: item1.post.spec.publishTime,
                };
                this.activeNews.push(obj2);
              }
              this.picturShowBox = this.picturBox.slice(0, 5);
            }
          });
      } else if (this.activeNew == "政策解读") {
        axios
          .get(
            Setting.getHalo() +
              "/v1alpha1/posts?page=1&size=8&labelSelector=content.halo.run%2Fdeleted%3Dfalse&fieldSelector=spec.categories%3Dcategory-upXaM&keyword=",
            config
          )
          .then((res) => {
            if (res.data.items.length != 0) {
              let index = 1;
              let total = 0;
              for (let i = 0; i < res.data.items.length; i++) {
                let item1 = res.data.items[i];
                if (item1.post.spec.cover) {
                  total += 1;
                }
              }
              for (let i = 0; i < res.data.items.length; i++) {
                let item1 = res.data.items[i];
                if (item1.post.spec.cover) {
                  let obj = {
                    img: item1.post.spec.cover ?'https://ntgl.tlsyjxndc.com:18004' +  item1.post.spec.cover : null,
                    discript: item1.post.spec.title,
                    active: index,
                    total: total,
                  };
                  this.indictorList.push(obj);
                  this.picturBox.push(obj);
                  index++;
                }

                let obj2 = {
                  index: i,
                  title: item1.post.spec.title,
                  name: item1.post.metadata.name,
                  publishTime: item1.post.spec.publishTime,
                };
                this.activeNews.push(obj2);
              }
              this.picturShowBox = this.picturBox.slice(0, 5);
            }
          });
      } else if (this.activeNew == "案例分析") {
        axios
          .get(
            Setting.getHalo() +
              "/v1alpha1/posts?page=1&size=8&labelSelector=content.halo.run%2Fdeleted%3Dfalse&fieldSelector=spec.categories%3Dcategory-YLoBe&keyword=",
            config
          )
          .then((res) => {
            if (res.data.items.length != 0) {
              let index = 1;
              let total = 0;
              for (let i = 0; i < res.data.items.length; i++) {
                let item1 = res.data.items[i];
                if (item1.post.spec.cover) {
                  total += 1;
                }
              }
              for (let i = 0; i < res.data.items.length; i++) {
                let item1 = res.data.items[i];
                if (item1.post.spec.cover) {
                  // console.log(item1.post.spec.cover)
                  let obj = {
                    img: item1.post.spec.cover ?'https://ntgl.tlsyjxndc.com:18004' +  item1.post.spec.cover : null,
                    discript: item1.post.spec.title,
                    active: index,
                    total: total,
                  };
                  this.indictorList.push(obj);
                  this.picturBox.push(obj);
                  index++;
                }

                let obj2 = {
                  index: i,
                  title: item1.post.spec.title,
                  name: item1.post.metadata.name,
                  publishTime: item1.post.spec.publishTime,
                };
                this.activeNews.push(obj2);
              }
              console.log(this.picturBox);
              this.picturShowBox = this.picturBox.slice(0, 5);
            }
          });
      } else if (this.activeNew == "技术共享") {
        axios
          .get(
            Setting.getHalo() +
              "/v1alpha1/posts?page=1&size=8&labelSelector=content.halo.run%2Fdeleted%3Dfalse&fieldSelector=spec.categories%3Dcategory-OIPiZ&keyword=",
            config
          )
          .then((res) => {
            if (res.data.items.length != 0) {
              let index = 1;
              let total = 0;
              for (let i = 0; i < res.data.items.length; i++) {
                let item1 = res.data.items[i];
                if (item1.post.spec.cover) {
                  total += 1;
                }
              }
              for (let i = 0; i < res.data.items.length; i++) {
                let item1 = res.data.items[i];
                if (item1.post.spec.cover) {
                  // console.log(item1.post.spec.cover)
                  let obj = {
                    img: item1.post.spec.cover ?'https://ntgl.tlsyjxndc.com:18004' +  item1.post.spec.cover : null,
                    discript: item1.post.spec.title,
                    active: index,
                    total: total,
                  };
                  this.indictorList.push(obj);
                  this.picturBox.push(obj);
                  index++;
                }

                let obj2 = {
                  index: i,
                  title: item1.post.spec.title,
                  name: item1.post.metadata.name,
                  publishTime: item1.post.spec.publishTime,
                };
                this.activeNews.push(obj2);
              }

              this.picturShowBox = this.picturBox.slice(0, 5);
            }
          });
      } else if (this.activeNew == "平台咨询") {
        axios
          .get(
            Setting.getHalo() +
              "/v1alpha1/posts?page=1&size=8&labelSelector=content.halo.run%2Fdeleted%3Dfalse&fieldSelector=spec.categories%3Dcategory-ajqMn&keyword=",
            config
          )
          .then((res) => {
            if (res.data.items.length != 0) {
              let index = 1;
              let total = 0;
              for (let i = 0; i < res.data.items.length; i++) {
                let item1 = res.data.items[i];
                if (item1.post.spec.cover) {
                  total += 1;
                }
              }
              for (let i = 0; i < res.data.items.length; i++) {
                let item1 = res.data.items[i];
                if (item1.post.spec.cover) {
                  // console.log(item1.post.spec.cover)
                  let obj = {
                    img: item1.post.spec.cover ?'https://ntgl.tlsyjxndc.com:18004' +  item1.post.spec.cover : null,
                    discript: item1.post.spec.title,
                    active: index,
                    total: total,
                  };
                  this.indictorList.push(obj);
                  this.picturBox.push(obj);
                  index++;
                }

                let obj2 = {
                  index: i,
                  title: item1.post.spec.title,
                  name: item1.post.metadata.name,
                  publishTime: item1.post.spec.publishTime,
                };
                this.activeNews.push(obj2);
              }

              this.picturShowBox = this.picturBox.slice(0, 5);
            }
          });
      }
    },

    handleNews(val) {
      this.activeNew = val;
      this.initNew();
    },
    //加入我们
    gotoSign() {
      window.open("https://ntgl.tlsyjxndc.com:18003/register");
    },
    //免费试用
    gotoSignFree() {
      window.open("https://ntgl.tlsyjxndc.com:18003/registerfree");
    },
    //联系我们
    guidanceDialogOpen() {
      this.guidanceDialog = true;
      this.guidanForm.entName = "";
      this.guidanForm.contact = "";
      this.guidanForm.phoneNumber = "";
      this.guidanForm.demand = "";
    },
    handlesubmit() {
      if (
        this.guidanForm.entName == "" ||
        this.guidanForm.contact == "" ||
        this.guidanForm.phoneNumber == "" ||
        this.guidanForm.demand == ""
      ) {
        return this.$message({
          message: "请输入信息",
          type: "warning",
        });
      }
      axios({
        method: "POST",
        url: "/door/enterprise/door/DoorInquiry",
        data: this.guidanForm,
      }).then((res) => {
        if (res.data.code != "200") return;
        this.$message({
          message: "提交成功",
          type: "success",
        });
        this.guidanceDialog = false;
      });
    },
    downloadFile(e) {
      if (e == 1) {
        window.open(
          "https://ntgl.tlsyjxndc.com:9001/carbon/halo-portal/%E5%B7%A5%E4%B8%9A%E4%BC%81%E4%B8%9A%E5%92%8C%E5%9B%AD%E5%8C%BA%E6%95%B0%E5%AD%97%E5%8C%96%E8%83%BD%E7%A2%B3%E7%AE%A1%E7%90%86%E4%B8%AD%E5%BF%83%E5%BB%BA%E8%AE%BE%E6%8C%87%E5%8D%97%EF%BC%88%E5%B7%A5%E4%BF%A1%E5%8E%85%E8%8A%82%E3%80%942025%E3%80%9513%E5%8F%B7%EF%BC%89.pdf"
        );
      }
      if (e == 2) {
        window.open(
          "https://ntgl.tlsyjxndc.com:9001/carbon/halo-portal/%E5%B7%A5%E4%B8%9A%E4%BC%81%E4%B8%9A%E6%B8%A9%E5%AE%A4%E6%B0%94%E4%BD%93%E6%8E%92%E6%94%BE%E6%A0%B8%E7%AE%97%E5%92%8C%E6%8A%A5%E5%91%8A%E9%80%9A%E5%88%99(GBT%2032150-2015).pdf"
        );
      }
      if (e == 3) {
        window.open(
          "https://ntgl.tlsyjxndc.com:9001/carbon/halo-portal/%E7%BB%BC%E5%90%88%E8%83%BD%E8%80%97%E8%AE%A1%E7%AE%97%E9%80%9A%E5%88%99%EF%BC%88GBT%202589-2020%EF%BC%89.pdf"
        );
      }
      if (e == 4) {
        window.open(
          "https://ntgl.tlsyjxndc.com:9001/carbon/halo-portal/%E4%BC%81%E4%B8%9A%E6%B8%A9%E5%AE%A4%E6%B0%94%E4%BD%93%E6%8E%92%E6%94%BE%E6%A0%B8%E7%AE%97%E4%B8%8E%E6%8A%A5%E5%91%8A%E6%8C%87%E5%8D%97%20%E9%92%A2%E9%93%81%E8%A1%8C%E4%B8%9A%20.pdf"
        );
      }
      if (e == 5) {
        window.open(
          "https://ntgl.tlsyjxndc.com:9001/carbon/halo-portal/%E4%BC%81%E4%B8%9A%E6%B8%A9%E5%AE%A4%E6%B0%94%E4%BD%93%E6%8E%92%E6%94%BE%E6%A0%B8%E7%AE%97%E4%B8%8E%E6%8A%A5%E5%91%8A%E6%8C%87%E5%8D%97%20%E6%B0%B4%E6%B3%A5%E8%A1%8C%E4%B8%9A%20.pdf"
        );
      }
      // if (e == 6) {
      //   window.open(
      //     "https://ntgl.tlsyjxndc.com:9001/carbon/halo-portal/%E6%B8%A9%E5%AE%A4%E6%B0%94%E4%BD%93%E4%BA%A7%E5%93%81%E7%A2%B3%E8%B6%B3%E8%BF%B9%E9%87%8F%E5%8C%96%E8%A6%81%E6%B1%82%E5%92%8C%E6%8C%87%E5%8D%97%EF%BC%88GBT%2024067%EF%BC%89.pdf"
      //   );
      // }
      if (e == 7) {
        window.open(
          "https://ntgl.tlsyjxndc.com:9001/carbon/halo-portal/%E4%BC%81%E4%B8%9A%E6%B8%A9%E5%AE%A4%E6%B0%94%E4%BD%93%E6%8E%92%E6%94%BE%E6%A0%B8%E7%AE%97%E4%B8%8E%E6%8A%A5%E5%91%8A%E6%8C%87%E5%8D%97%20%E9%93%9D%E5%86%B6%E7%82%BC%E8%A1%8C%E4%B8%9A%20.pdf"
        );
      }
      // if (e == 8) {
      //   window.open(
      //     "https://ntgl.tlsyjxndc.com:9001/carbon/halo-portal/CBAM%E5%A1%AB%E6%8A%A5%E7%A4%BA%E4%BE%8B%E6%96%87%E4%BB%B6.zip"
      //   );
      // }
      if (e == 9) {
        window.open(
          "https://ntgl.tlsyjxndc.com:9001/carbon/halo-portal/%E7%BB%84%E7%BB%87%E5%B1%82%E9%9D%A2%E6%B8%A9%E5%AE%A4%E6%B0%94%E4%BD%93%E6%8E%92%E6%94%BE%E9%87%8F%E5%92%8C%E6%B8%85%E9%99%A4%E9%87%8F%E9%87%8F%E5%8C%96%E5%92%8C%E6%8A%A5%E5%91%8A%E6%8C%87%E5%8D%97%E8%A7%84%E8%8C%83%EF%BC%88iso14064-1%EF%BC%89.pdf"
        );
      }
      if (e == 10) {
        window.open(
          "https://ntgl.tlsyjxndc.com:9001/carbon/halo-portal/%E6%B8%A9%E5%AE%A4%E6%B0%94%E4%BD%93%E6%8E%92%E6%94%BE%E6%A0%B8%E7%AE%97%E4%B8%8E%E6%8A%A5%E5%91%8A%E8%A6%81%E6%B1%82%20%E7%82%AD%E7%B4%A0%E6%9D%90%E6%96%99%E7%94%9F%E4%BA%A7%E4%BC%81%E4%B8%9A.pdf"
        );
      }
    },
    gotoLink1() {
      window.open("https://sthjj.tongliao.gov.cn/");
    },
    gotoLink2() {
      window.open("https://fgw.tongliao.gov.cn/");
    },
    handleRightNav(val) {
      if (val == 1) {
        window.open("https://ntgl.tlsyjxndc.com:18002");
      } else if (val == 2) {
        window.open("https://ntgl.tlsyjxndc.com:18003");
      } else if (val == 3) {
        window.open("https://ntgl.tlsyjxndc.com:18003/registerfree");
      } else if (val == 4) {
        window.open("/login");
      } else if (val == 5) {
        this.guidanceDialogOpen();
      } else if (val == 6) {
        const container = this.$refs.scrollContainer;
        // 平滑滚动（现代浏览器）
        container.scrollTo({
          top: 0,
          behavior: "smooth",
        });

        // 兼容写法
        // container.scrollTop = 0;
      }
    },
    goToMore() {
      if (this.activeNew == "双碳要闻") {
        this.$router.push({
          path: "/tableDetail",
          query: { titleName: this.activeNew, activeName: 2 },
        });
      } else if (this.activeNew == "政策解读") {
        this.$router.push({
          path: "/tableDetail",
          query: { titleName: this.activeNew, activeName: 4 },
        });
      } else if (this.activeNew == "案例分析") {
        this.$router.push({
          path: "/tableDetail",
          query: { titleName: this.activeNew, activeName: 6 },
        });
      } else if (this.activeNew == "技术共享") {
        this.$router.push({
          path: "/tableDetail",
          query: { titleName: this.activeNew, activeName: 7 },
        });
      } else if (this.activeNew == "平台咨询") {
        this.$router.push({
          path: "/tableDetail",
          query: { titleName: this.activeNew, activeName: 9 },
        });
      }
    },
    handleCarousel(newVal, oldVal) {
      if (this.picturBox.length > 5) {
        if (newVal == 5) {
          this.picturShowBox = this.picturBox.slice(5, 10);
        }
        console.log(newVal);
        if (newVal == 0) {
          this.picturShowBox = this.picturBox.slice(0, 5);
        }
        if (newVal < 5) {
          this.picturShowBox = this.picturBox.slice(0, 5);
        }
      }
      if (newVal < 5) {
        this.activeCurrentNews = newVal;
      } else {
        this.activeCurrentNews = Number(newVal % 5);
      }
    },
    handleItem(item) {
      this.$refs.carousel.setActiveItem(item.active - 1);
    },
    // 格式化时间的方法
    formatDateTime(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 更新时间的方法
    updateDateTime() {
      this.Datetime = this.formatDateTime(new Date());
    },

    // 启动时间更新定时器
    // startTimeUpdater() {
    //   this.updateDateTime(); // 立即执行一次
    //   this.timer = setInterval(this.updateDateTime, 1000);
    // },
        // 启动时间更新定时器（每10分钟更新一次）
    startTimeUpdater() {
      // 立即执行一次
      this.updateDateTime();
      
      // 每10分钟更新一次时间 (10 * 60 * 1000毫秒)
      this.datetimeTimer = setInterval(() => {
        this.updateDateTime();
      }, 10 * 60 * 1000);
    },

       // 停止时间更新定时器
    stopTimeUpdater() {
      if (this.datetimeTimer) {
        clearInterval(this.datetimeTimer);
        this.datetimeTimer = null;
      }
    },
  },
  mounted() {
    // 启动时间更新
    this.startTimeUpdater();
    this.initNew();
    this.getNews();
    // 启动碳市场数据定时更新
    this.startCarbonMarketTimer();
  },
  beforeDestroy() {
   // 清理定时器，防止内存泄漏
    this.stopTimeUpdater();
    // 清理碳市场数据定时器
    this.stopCarbonMarketTimer();
  },
};
</script>
<style lang="less" scoped>
.door-home {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  position: relative;
  background: #ffffff;
  .container-center {
    width: 1328px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .door-header {
    width: 100%;
    height: 750px;
    position: relative;

    .door-nav {
      height: 70px;
      width: 100%;
      position: absolute;
      top: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 2;
      .door-logo {
        width: 467px;
        height: 36px;
        margin-left: 20px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .door-info {
        margin-right: 20px;
        height: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .door-info-telephone {
          margin-right: 30px;
          height: 30px;
          width: 151px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .tele-box {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            border: 1px solid #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: 16px;
              height: 16px;
            }
          }

          div {
            font-family: ArialMT;
            font-size: 16px;
            color: #ffffff;
            font-style: normal;
          }
        }
        .door-info-contact {
          height: 30px;
          width: 80px;
          border: 1px solid #fff;
          border-radius: 4px;
          line-height: 30px;
          text-align: center;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #ffffff;
          font-style: normal;
          &:hover {
            transform: scale(1.05); // 按钮放大效果
            cursor: pointer;
            background: linear-gradient(
              270deg,
              rgba(255, 255, 255, 0.2) 0%,
              /* 降低白色透明度 */ rgba(210, 209, 209, 0.2) 100%
                /* 降低灰色透明度 */
            );
            /* 保留文字颜色为白色 */
            color: #ffffff;
            /* 边框颜色过渡效果 */
            border-color: rgba(255, 255, 255, 0.6);
            /* 添加微光效果 */
          }
        }
      }
    }
    .door-title-box {
      position: absolute;
      width: 913px;
      height: 356px;
      top: 197px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      .door-title {
        width: 100%;
        height: 223px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .door-btn {
        width: 206px;
        height: 60px;
        background: linear-gradient(270deg, #06bcff 0%, #017de9 100%);
        box-shadow: 0px 9px 25px 0px rgba(11, 133, 239, 0.62);
        border-radius: 30px;
        font-family: TencentSansW7;
        font-size: 24px;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
        img {
          width: 21px;
          height: 18px;
        }
        &:hover {
          cursor: pointer;
          transform: scale(1.05); // 按钮放大效果
          box-shadow: 0px 12px 30px 0px rgba(11, 133, 239, 0.8); // 阴影增强效果
        }
      }
    }
    .door-card {
      position: absolute;
      top: 707px;
      height: 260px;
      width: 1281px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .door-card-item {
        width: 297px;
        height: 100%;
        background: #ffffff;
        box-shadow: 0px 8px 22px 0px rgba(0, 0, 0, 0.08);
        border-radius: 4px;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        align-items: center;
        &:hover {
          cursor: pointer;
          transform: scale(1.02); // 按钮放大效果
          box-shadow: 0px 8px 22px 0px rgba(0, 0, 0, 0.1);
        }
        .door-card-title {
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 18px;
          color: #333333;
          font-style: normal;
        }
        .door-card-discript {
          width: 256px;
          font-family: MicrosoftYaHei;
          font-size: 14px;
          color: #666666;
          text-align: center;
          word-wrap: break-word; // 允许长单词或 URL 换行
          white-space: normal; // 允许文本换行（默认值）
        }
      }
      .door-card-item:nth-child(1) {
        .door-card-img {
          margin-top: 13px;
          width: 158px;
          height: 134px;
          background: url("../../../assets/door/card1.png") no-repeat;
          background-size: 100% 100%;
        }
        .door-card-title {
          margin-top: 11px;
        }
        .door-card-discript {
          margin-top: 11px;
        }
      }
      .door-card-item:nth-child(2) {
        .door-card-img {
          margin-top: 17px;
          width: 118px;
          height: 129px;
          background: url("../../../assets/door/card2.png") no-repeat;
          background-size: 100% 100%;
        }
        .door-card-title {
          margin-top: 12px;
        }
        .door-card-discript {
          margin-top: 14px;
        }
      }
      .door-card-item:nth-child(3) {
        .door-card-img {
          margin-top: 33px;
          width: 123px;
          height: 102px;
          background: url("../../../assets/door/card3.png") no-repeat;
          background-size: 100% 100%;
        }
        .door-card-title {
          margin-top: 23px;
        }
        .door-card-discript {
          margin-top: 14px;
        }
      }
      .door-card-item:nth-child(4) {
        .door-card-img {
          margin-top: 13px;
          width: 137px;
          height: 148px;
          background: url("../../../assets/door/card4.png") no-repeat;
          background-size: 100% 100%;
        }
        .door-card-title {
          margin-top: 0px;
        }
        .door-card-discript {
          margin-top: 14px;
        }
      }
    }
  }

  .header-title-box {
    width: 100%;
    // height: 403px;
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    .header-title {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 32px;
      color: #333333;
      margin-bottom: 21px;
    }
    .header-title-info {
      font-family: MicrosoftYaHei;
      font-size: 18px;
      color: #666666;
      line-height: 14px;
      margin-bottom: 25px;
    }
  }
  .common-monitor {
    width: 100%;
    height: 540px;

    display: flex;
    justify-content: center;
    align-items: center;

    .container-left {
      width: 674px;
      height: 419px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .container-right {
      width: 564px;
      height: 376px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      .product-title {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 34px;
        color: #ffffff;
        .active {
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-size: 36px;
          color: #1ed3ff;
          font-style: italic;
          font-weight: bold;
          margin-left: 6px;
          margin-right: 9px;
        }
      }
      .product-line {
        width: 80px;
        height: 5px;
        background: #ffffff;
        margin-top: 33px;
      }
      .product-box-title {
        margin-top: 23px;
        width: 560px;
        height: 90px;
        font-family: MicrosoftYaHei;
        font-size: 18px;
        color: #ffffff;
      }
      .product-box-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 90px;
        justify-content: space-between;
        align-items: flex-start;
        .product-box-info-item {
          height: 33.3%;
          width: 100%;
          font-family: MicrosoftYaHei;
          font-size: 16px;
          color: #ffffff;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          span.bg-icon {
            display: inline-block;
            width: 12px;
            height: 12px;
            background-color: rgba(163, 167, 169, 0.631);
            margin-right: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            span {
              display: inline-block;
              width: 4px;
              height: 4px;
              background-color: #fff;
            }
          }
        }
      }
      .product-box-btn {
        margin-top: 34px;
        width: 130px;
        height: 52px;
        background: #017de9;
        box-shadow: 0px 4px 16px 0px rgba(1, 125, 233, 0.2);
        border-radius: 4px;
        line-height: 52px;
        text-align: center;
        font-family: MicrosoftYaHei;
        font-size: 20px;
        color: #ffffff;
        &:hover {
          cursor: pointer;
          transform: scale(1.05); // 按钮放大效果
        }
      }
    }
  }
  .carbon-monitor {
    background: url("../../../assets/door/carbon.png") no-repeat;
    background-size: 100% 100%;
  }
  .carbon-calendar {
    background: url("../../../assets/door/carbonCalendar.png") no-repeat;
    background-size: 100% 100%;
    .container-left {
      img {
        width: 100%;
        height: 90%;
        //  width: auto;
        //  height: 419px;
      }
    }
  }
  .carbon-matching {
    background: url("../../../assets/door/carbonMatching.png") no-repeat;
    background-size: 100% 100%;
  }
  .carbon-finance {
    background: url("../../../assets/door/finance.png") no-repeat;
    background-size: 100% 100%;
  }
  .common-show {
    width: 100%;
    height: 540px;
    display: flex;
    justify-content: center;
    align-items: center;
    .container-left {
      width: 583px;
      height: 377px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      .product-title {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 34px;
        color: #333333;
        .active {
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-size: 36px;
          color: #1ed3ff;
          font-style: italic;
          font-weight: bold;
          margin-left: 6px;
          margin-right: 9px;
        }
      }
      .product-line {
        width: 80px;
        height: 5px;
        background: #017de9;
        margin-top: 33px;
      }
      .product-box-title {
        margin-top: 23px;
        width: 560px;
        height: 90px;
        font-family: MicrosoftYaHei;
        font-size: 18px;
        color: #333333;
      }
      .product-box-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 90px;
        justify-content: space-between;
        align-items: flex-start;
        .product-box-info-item {
          height: 33.3%;
          width: 100%;
          font-family: MicrosoftYaHei;
          font-size: 16px;
          color: #333333;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          span.bg-icon {
            display: inline-block;
            width: 12px;
            height: 12px;
            background-color: rgba(225, 240, 253, 1);
            margin-right: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            span {
              display: inline-block;
              width: 4px;
              height: 4px;
              background-color: #017de9;
            }
          }
        }
      }
      .product-box-btn {
        margin-top: 34px;
        width: 130px;
        height: 52px;
        background: #017de9;
        box-shadow: 0px 4px 16px 0px rgba(1, 125, 233, 0.2);
        border-radius: 4px;
        line-height: 52px;
        text-align: center;
        font-family: MicrosoftYaHei;
        font-size: 20px;
        color: #ffffff;
        &:hover {
          cursor: pointer;
          transform: scale(1.05); // 按钮放大效果
        }
      }
    }
    .container-right {
      width: 689px;
      height: 407px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .public-box {
    width: 100%;
    height: 780px;

    display: flex;
    justify-content: center;
    align-items: center;
    background: url("../../../assets/door/public.png") no-repeat;
    background-size: 100% 100%;
    .public-center {
      width: 1328px;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      .public-title {
        margin-top: 80px;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 32px;
      }
      .public-content {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 465px;
        margin-top: 51px;
        .public-left {
          width: 626px;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          .carousel-top {
            width: 100%;
            height: 353px;

            .indictorInfo {
              position: absolute;
              bottom: 0;
              background: rgba(0, 0, 0, 0.4);

              width: 100%;
              height: 46px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .indictorInfoLeft {
                width: 432px;
                margin-left: 21px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: rgba(255, 255, 255, 0.8);
                white-space: nowrap; // 禁止换行
                overflow: hidden; // 隐藏超出内容
                text-overflow: ellipsis; // 显示省略号
              }
              .indictorInfoRight {
                margin-right: 24px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: rgba(255, 255, 255, 0.8);
              }
            }
          }
          .carousel-bottom {
            margin-top: 11px;
            width: 100%;
            height: 101px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .carousel-bottom-item {
              margin-right: 10px;
              width: calc(20% - 8px);
              height: 100%;
              background-size: cover; /* 确保图片覆盖整个元素 */
              background-position: center; /* 图片居中显示 */
              background-repeat: no-repeat; /* 防止图片重复 */
            }
            .carousel-bottom-item-active {
              transform: scale(1.1); // 按钮放大效果
              border: 1px solid #a3a1a1;
            }
            .carousel-bottom-item:last-child {
              margin-right: 0px;
            }
          }
        }
        .public-right {
          width: 625px;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          .public-btn-box {
            width: 100%;
            height: 45px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .btn {
              width: 118px;
              height: 45px;
              line-height: 45px;
              text-align: center;
              background: #ffffff;
              border-radius: 4px;
              border: 1px solid #eeeeee;
              margin-right: 15px;
              color: #333;
              a {
                color: #333;
              }
              &:hover {
                cursor: pointer;
                a {
                  color: #ffffff;
                }
                background: #017de9;
              }
            }
            .active {
              a {
                color: #ffffff;
              }
              background: #017de9;
            }
          }
          .public-info-list {
            margin-top: 20px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            .public-info-item {
              height: 50px;
              display: flex;
              width: 100%;
              justify-content: space-between;
              align-items: center;
              border-bottom: 1px dashed #d9d9d9;
              &:hover {
                cursor: pointer;
                .public-item-left {
                  color: #017de9;
                }
              }
              .public-item-right {
                width: 93px;
                line-height: 50px;
                margin-left: 34px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #666666;
              }

              .public-item-left {
                width: calc(100% - 117px);
                height: 100%;
                line-height: 48px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #333333;
                white-space: nowrap; // 禁止换行
                overflow: hidden; // 隐藏超出内容
                text-overflow: ellipsis; // 显示省略号
                span {
                  display: inline-block;
                  width: 8px;
                  height: 8px;
                  background: #017de9;
                  border-radius: 4px;
                  margin-right: 13px;
                }
              }
            }
          }
        }
      }
      .public-btn {
        margin-top: 42px;
        width: 147px;
        height: 52px;
        border-radius: 4px;
        border: 2px solid #017de9;
        line-height: 52px;
        text-align: center;
        font-family: 微软雅黑;
        font-size: 20px;
        color: #017de9;
        &:hover {
          cursor: pointer;
          background: linear-gradient(to right, #017de9, #01b6e9);
          color: #fff;
          border: 1px solid #fff;
          color: #fff;
        }
      }
    }
  }
  .download-box {
    margin-top: 43px;
    background: url("../../../assets/door/download.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .download-center {
      width: 1328px;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    }
    .download-title {
      margin-top: 38px;
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 32px;
    }
    .download-content {
      width: 100%;
      margin-top: 60px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      .download-item {
        width: calc(25% - 15px);
        height: 167px;
        background: #ffffff;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
        border: 1px solid #dddddd;
        margin-bottom: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        &:hover {
          cursor: pointer;
          background: url("../../../assets/door/downloadActive.png") no-repeat;
          background-size: 100% 100%;
          border: 0;
          transform: scale(1.02); // 按钮放大效果
          box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.4);
          .download-item-info {
            color: #ffffff;
          }
        }
        .download-item-img {
          width: 53px;
          height: 60px;
          margin-top: 19px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .download-item-info {
          margin-top: 28px;
          text-align: center;
          width: 258px;
          word-wrap: break-word; // 允许长单词或 URL 换行
          white-space: normal; // 允许文本换行（默认值）
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
        }
      }
    }
  }
  .footer-box {
    width: 100%;
    height: 500px;
    background: #0d2f4c;
    display: flex;
    justify-content: center;
    align-items: center;
    .footer-center {
      width: 1328px;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .footer-contact {
        margin-top: 70px;
        width: 100%;
        height: 355px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        .contact-img {
          width: 213px;
          height: 303px;
          border-right: 1px solid rgba(255, 255, 255, 0.3);
          display: flex;
          flex-direction: column;
          .consult-service {
            width: 150px;
            height: 42px;
            background: linear-gradient(270deg, #06bcff 0%, #017de9 100%);
            box-shadow: 0px 9px 25px 0px rgba(11, 133, 239, 0.62);
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            line-height: 42px;
            font-family: TencentSansW7;
            font-size: 20px;
            color: #ffffff;
            &:hover {
              cursor: pointer;
              transform: scale(1.02); // 按钮放大效果
              box-shadow: 0px 9px 25px 0px rgba(11, 133, 239, 0.72);
            }
            img {
              width: 27px;
              height: 27px;
              margin-right: 7px;
            }
          }
          .QR {
            margin-top: 24px;
            width: 150px;
            height: 152px;
          }
        }
        .contact-info {
          width: 212px;
          height: 303px;
          border-right: 1px solid rgba(255, 255, 255, 0.3);
          padding-left: 22px;
          display: flex;
          flex-direction: column;
          .contact-title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #ffffff;
          }
          .contact-divide-line {
            margin-top: 16px;
            width: 38px;
            height: 2px;
            background-color: rgba(255, 255, 255, 0.5);
          }
          .contact-item {
            margin-top: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: rgba(255, 255, 255, 0.5);
          }
          .contact-item:nth-child(1) {
            margin-top: 16px;
          }
        }
        .contact-extra {
          // width: 212px;
          height: 303px;
          padding-left: 22px;
          display: flex;
          flex-direction: column;
          .contact-title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #ffffff;
          }
          .contact-divide-line {
            margin-top: 16px;
            width: 38px;
            height: 2px;
            background-color: rgba(255, 255, 255, 0.5);
          }
          .contact-logo {
            margin-top: 16px;
            width: 378px;
            height: 34px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .contact-infos {
            margin-top: 22px;
            line-height: 30px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: rgba(255, 255, 255, 0.5);

            word-wrap: break-word; // 允许长单词或 URL 换行
            white-space: normal; // 允许文本换行
            display: flex;
            align-items: flex-start;
            line-height: 20px;
            .left-img-logo {
              height: 30px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            img {
              width: 16px;
              height: 16px;
              opacity: 0.5;
              margin-right: 12px;
            }
          }
        }
      }
      .footer-link {
        height: calc(100% - 425px);
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #fafafa;
          display: inline-block;
          width: 80px;
        }
        a {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.7);
          margin-right: 17px;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
  .right-nav {
    position: fixed;
    z-index: 333;
    top: 811px;
    right: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 413px;
    background: #e9f4fe;
    box-shadow: 0px 4px 16px 0px rgba(30, 79, 133, 0.26);
    border-radius: 4px;
    border: 1px solid #cae7ff;
    transition: top 2s ease; /* 添加过渡效果 */
    .nav-item {
      width: 100%;
      height: 20%;
      border-bottom: 1px solid #cae7ff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      &:hover {
        cursor: pointer;
        background: #118af2;
        color: #ffffff;
      }
    }
    .nav-item:nth-child(1) {
      .img-box {
        background: url("../../../assets/door/gov.svg");
        width: 34px;
        height: 32px;
      }
    }
    .nav-item:nth-child(1):hover {
      .img-box {
        background: url("../../../assets/door/gov-active.svg");
        width: 34px;
        height: 32px;
      }
    }
    .nav-item:nth-child(2) {
      .img-box {
        width: 35px;
        height: 35px;
        background: url("../../../assets/door/internet.svg");
      }
    }
    .nav-item:nth-child(2):hover {
      .img-box {
        width: 35px;
        height: 35px;
        background: url("../../../assets/door/internet-active.svg");
      }
    }
    .nav-item:nth-child(3) {
      .img-box {
        width: 36px;
        height: 36px;
        background: url("../../../assets/door/service.svg");
      }
    }
    .nav-item:nth-child(3):hover {
      .img-box {
        width: 36px;
        height: 36px;
        background: url("../../../assets/door/service-active.svg");
      }
    }
    /*.nav-item:nth-child(4) {
      .img-box {
        width: 35px;
        height: 35px;
        background: url("../../../assets/door/tph.svg");
      }
    }
    .nav-item:nth-child(4):hover {
      .img-box {
        width: 35px;
        height: 35px;
        background: url("../../../assets/door/tph-active.svg");
      }
    }*/
    .nav-item:nth-child(4) {
      .img-box {
        width: 32px;
        height: 35px;
        background: url("../../../assets/door/phone.svg");
      }
    }
    .nav-item:nth-child(4):hover {
      .img-box {
        width: 32px;
        height: 35px;
        background: url("../../../assets/door/phone-active.svg");
      }
    }
    .nav-item:nth-child(5) {
      .img-box {
        width: 28px;
        height: 25px;
        background: url("../../../assets/door/up.svg");
      }
    }
    .nav-item:nth-child(5):hover {
      .img-box {
        width: 28px;
        height: 25px;
        background: url("../../../assets/door/up-active.svg");
      }
    }
    .nav-item:last-child {
      border: 0;
    }
  }
}

::v-deep .el-carousel__container {
  width: 100%;
  height: 100%;
  // overflow: hidden;
  overflow-x: hidden;
}
::v-deep .el-carousel__item {
  top: 0;
}
// ::v-deep .el-carousel__indicators--outside {
//     display: none;
// }
</style>
<style lang="less">
.guidanceBox {
  .el-dialog__header {
    display: none !important;
  }
  .el-dialog__body {
    position: relative;
    background: linear-gradient(180deg, #cde7ff 0%, #ffffff 79%);
    box-shadow: 0px 8px 18px 0px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    height: 502px;
    padding: 0px !important;
    .headerBox {
      display: flex;
      align-items: center;
      height: 149px;
      padding-left: 80px;
      padding-right: 133px;
      background: url(../images/位图.png) no-repeat;
      background-position: 95% 25px;
      .titleInfoBox {
        display: flex;
        flex-direction: column;
        .title1 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 25px;
          color: #333333;
          img {
            width: 30px;
            height: 23px;
            margin-left: 5px;
          }
        }
        .title2 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 13px;
          color: #666666;
        }
      }
    }
    .bodyBox {
      display: flex;
      flex-direction: column;
      padding: 0px 80px;
      ::v-deep .el-form {
        .el-form-item__label {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #333333;
        }
      }
      .submitBox {
        align-self: center;
        background: #017de7;
        border-radius: 4px;
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
      }
    }
    .closeBox {
      position: absolute;
      bottom: -50px;
      left: 47%;
      background: url(../images/关闭.svg) no-repeat;
      width: 38px;
      height: 38px;
    }
  }
}
.bj {
  width: 100%;
  height: 187px;
  background: #fff;
}
.zhhq {
  width: 100%;
  height: 412px;
  background: url(../images/tjy/每日行情背景.png) no-repeat;
  background-size: 100% 100%; /* 强制拉伸图片以填满容器 */
  .zTop {
    h1.market-title {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      font-size: 32px;
      color: #333;
      padding-top: 93px;

      .title-center {
        flex: 1;
      }

      .title-right {
        position: absolute;
        right: 375px;
        font-size: 18px;
        font-weight: bolder;
        margin-top: 25px;
      }
    }
  }
  .zTop {
    h1 {
      text-align: center;
      font-size: 32px;
      color: #333;
      padding-top: 93px;
    }
  }
  .zMain {
    display: flex;
    width: 70%;
    /* margin: auto; */
    margin-top: 30px;
    margin-left: 20%;
    .zLeft {
      width: 27.5%;
      height: 205px;
      background: linear-gradient(180deg, #88c7fd 0%, #eff8ff 100%);
      .lTop {
        height: 115px;
        border-bottom: 1px solid #fff;
        p {
          font-size: 18px;
          color: #333;
          text-align: center;
          margin-top: 20px;
        }
        div {
          text-align: center;
          .sps1 {
            font-size: 26px;
            font-weight: bold;
            color: #333;
          }
          .sps2 {
            font-size: 16px;
            color: #999;
          }
        }
      }
      .lBottom {
        display: flex;
        .lBottom-left,
        .lBottom-right {
          width: 50%;
          border-right: 1px solid #fff;
          .positive {
            color: #ff5757; /* 红色表示正数 */
            font-size: 16px;

            font-weight: bold;
            margin-left: 5px;
          }
          .negative {
            color: #2ecc71; /* 绿色表示负数 */
            font-size: 16px;

            font-weight: bold;
            margin-left: 5px;
          }
          p {
            text-align: center;
            line-height: 70px;
            .sps1 {
              font-size: 14px;
              color: #333;
            }
            .sps2 {
              font-size: 16px;
              color: #333;
              font-weight: bold;
              margin-left: 5px;
            }
          }
        }
        .lBottom-right {
          border-right: none;
        }
      }
    }
    .zRight {
      width: 80%;
      display: flex;
      flex-wrap: wrap; /* 允许换行 */
      width: 100%;
      gap: 10px; /* 设置项目之间的间距 */
      margin-left: 20px;
      .z-item {
        display: flex;
        height: 92px;

        width: 27.5%;
        background-color: #fff;
        border-radius: 8px;
        border: 1px solid #e5e9ed;
        .zleft {
          margin-left: 20px;
          margin-top: 20px;
        }
        .zright {
          margin-left: 20px;
          .P1 {
            margin-top: 20px;
            font-size: 14px;
          }
          .p2 {
            .sps1 {
              font-size: 20px;
            }
            .sps2 {
              font-size: 12px;
              color: #999;
            }
          }
        }
      }
    }
  }
}

.cjy {
  width: 100%;

  height: 714px;
  background: url(../images/tjy/交易撮合背景.png) no-repeat;
  background-size: 100% 100%; /* 强制拉伸图片以填满容器 */
  h1 {
    text-align: center;
    font-size: 32px;
    color: #333;
    padding-top: 67px;
  }
  p {
    text-align: center;
    font-size: 18px;
    color: #666;
  }
  .cMain {
    display: flex;
    width: 70%;
    margin: auto;
    margin-top: 30px;
    .mLeft {
      width: 20%;
      height: 474px;
      background: url(../images/tjy/累计交易撮合统计.png) no-repeat;
      border-radius: 10px;
      h2 {
        font-size: 14px;
        color: #fff;
        margin-left: 20px;
        margin-top: 10px;
        span {
          vertical-align: middle;
        }
        .sps2 {
          margin-left: 6px;
        }
      }
      .lBottom {
        .lBottom-item {
          width: 80%;
          height: 179px;
          margin-left: 10%;
          margin-top: 20px;
          text-align: center;
          border: 1px solid #fff;
          border-radius: 10px;
          background: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 1),
            /* 纯白 */ rgba(255, 255, 255, 0) /* 完全透明 */
          );
          .item-title {
            font-size: 14px;
            margin-top: 47px;
            span {
              vertical-align: middle;
            }
          }
          .item-num {
            margin-top: 10px;
            .num {
              font-size: 34px;
            }
            .yuan {
              font-size: 14px;
              color: #0006ff;
              margin-left: 5px;
            }
          }
        }
      }
    }
    .mRight {
      width: 80%;
      // display: flex;
      .rTop {
        display: flex;

        flex-wrap: wrap; /* 允许换行 */
        width: 100%;
        gap: 20px; /* 设置项目之间的间距 */

        .rTop-item {
          margin-left: 20px;
          width: 30%;
          background: linear-gradient(to bottom, #e6f9e4, #ffffff);
          height: 224px;
          .title1 {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
          }
          .title2 {
            margin-left: 10px;
            span {
              vertical-align: middle;
            }
            .bt {
              font-size: 18px;
              font-weight: bold;
              margin-left: 6px;
            }
          }
          .title3 {
            .bt {
              font-size: 14px;
              color: #333;
              display: inline-block;
              margin-top: 5px;
            }
            p {
              margin-left: 5px;
            }
            .num {
              font-size: 20px;
            }
            .dw {
              font-size: 12px;
              color: #999;
              margin-left: 5px;
            }
            margin-right: 10px;
            display: flex;
          }
          .items {
            display: flex;
            flex-wrap: wrap; /* 允许换行 */
            gap: 16px; /* 设置项目之间的间距 */
            margin-top: 10px;
          }

          .title-item {
            width: 43%;
            // flex: 1 0 calc(45% - 8px); /* 每个项目占50%宽度减去一半的gap */
            min-width: 0; /* 防止内容溢出 */
            box-sizing: border-box; /* 包含padding和border在宽度内 */
            height: 73px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid #e5e9ed;
            padding-left: 10px;
            margin-left: 10px;
          }

          /* 其他样式可以根据需要添加 */
          .item-title {
            font-size: 14px;
            color: #333;
            margin-top: 10px;
          }

          .item-num {
            margin-top: 10px;
            .yuanNum {
              font-size: 20px;
              font-weight: bold;
              color: #333;
            }
            .dw {
              color: #999;
              font-size: 12px;
              margin-left: 5px;
            }
          }
        }
      }
    }
  }
}
</style>
